module.exports = __webpack_public_path__ + "static/full-545596d9b89e77f923785ba0008e6c83.png";